import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription, filter } from 'rxjs';
import { Command } from 'src/app/model/command';
import { DeviceStatus } from 'src/app/model/device-status';
import { ERoles } from 'src/app/model/role';
import { User } from 'src/app/model/user';

import { AppState } from 'src/app/store/app.reducer';
import { selectCurrentDeviceCommands, selectCurrentDeviceStatus } from 'src/app/store/device/device.selector';
import { selectUser } from 'src/app/store/user/user.selector';
import * as DeviceActions from 'src/app/store/device/device.actions';


@Component({
    selector: 'app-io-commands',
    templateUrl: './io-commands.component.html',
    providers: [],
})
export class IoCommandsComponent implements OnInit, OnDestroy {
    commands$: Observable<Command[] | undefined>;
    commandsSub: Subscription | undefined;
    currentUser$: Observable<User | undefined>;
    currentUserSub: Subscription | undefined;
    deviceStatus$: Observable<DeviceStatus | undefined>;
    deviceStatusSub: Subscription | undefined;

    splittedCommands: Command[][] = [];

    isUser: boolean;
    isTechnician: boolean;

    deviceOnline: boolean;
    deviceConfigured: boolean;


    // Design
    screenWidth: number;
    MIN_MD_WIDTH = 500;
    MAX_MD_WIDTH = 1120;
    MAX_MD_WIDTH_SHORT = 858;
    LG_WIDTH = 1500;

    constructor(
        private store: Store<AppState>
    ) {
        this.initSelectors();
    }


    initSelectors(): void {
        this.commands$ = this.store.select(selectCurrentDeviceCommands);
        this.currentUser$ = this.store.select(selectUser);
        this.deviceStatus$ = this.store.select(selectCurrentDeviceStatus);
    }

    ngOnInit(): void {
        this.commandsSub = this.commands$.subscribe(
            commands => { this.splitCommands(commands); }
        );
        this.currentUserSub = this.currentUser$.subscribe(user => {
            const role = user.Roles[0];
            if (role.Description === ERoles.User) {
                this.isUser = true;
            } else {
                this.isTechnician = true;
            }
        });
        this.deviceStatusSub = this.deviceStatus$.pipe(filter(deviceState => !!deviceState))
            .subscribe(
                deviceState => {
                    this.deviceOnline = deviceState.Online;
                    this.deviceConfigured = deviceState.Configured === 0;
                }
            );
    }

    ngOnDestroy(): void {
        this.deviceStatusSub?.unsubscribe();
        this.currentUserSub?.unsubscribe();
        this.commandsSub?.unsubscribe();
    }

    splitCommands(commands: Command[]): void {
        if (!commands) {
            return;
        }
        this.splittedCommands = [];
        for (let i = 0; i < 10; i++) {
            const cmds = commands.filter(c => c.OutputId === i);
            if (cmds.length > 0) {
                this.splittedCommands.push(cmds);
            }
        }
    }

    deviceConfiguredOnline(): boolean {
        return this.deviceConfigured && this.deviceOnline;
    }

    executeCommand(commandId: number): void {
        this.store.dispatch(DeviceActions.executeCommand({ commandId }));
    }



    @HostListener('window:resize', ['$event'])
    onResize() {
        this.screenWidth = window.innerWidth;
        this.minWidthDialog();
    }

    onMobile(): boolean {
        return (this.screenWidth <= this.MIN_MD_WIDTH);
    }

    onTablet(): boolean {
        return (this.screenWidth >= this.MIN_MD_WIDTH) && (this.screenWidth <= this.MAX_MD_WIDTH_SHORT);
    }

    minWidthDialog(): string {
        return (this.screenWidth > this.MAX_MD_WIDTH) ? "w-72rem" : "";
    }

    col12Responsive(): string {
        return (this.screenWidth <= this.MAX_MD_WIDTH) ? "col-12 p-2" : "col-6 p-2";
    }

    col12Action(): string {
        return (this.screenWidth <= this.MIN_MD_WIDTH) ? "col-12" : "";
    }
}
